<template>
  <div
    class="fixed inset-0 z-[2300] flex items-center justify-center bg-[rgba(9,20,51,0.48)] px-[16px]"
  >
    <div
      class="relative w-full max-w-[500px] rounded-[16px] bg-white px-[24px] pt-[24px] pb-[24px] shadow-[0_20px_60px_rgba(8,19,62,0.24)]"
    >
      <button
        type="button"
        class="absolute top-[24px] right-[24px] flex h-[24px] w-[24px] items-center justify-center text-[#7d818a] transition-transform duration-300 hover:rotate-90"
        @click="emit('close')"
      >
        <CloseIcon class="h-[14px] w-[14px]" />
      </button>

      <div class="text-[18px] leading-[26px] font-semibold text-[#292a2e]">请输入图形验证码</div>

      <div class="mt-[28px] flex items-center justify-between gap-[16px]">
        <div class="h-[50px] w-[112px] overflow-hidden rounded-[8px] border border-[rgba(5,21,36,0.08)] bg-[#f8f8f8]">
          <CommonImage :src="graphicalImg" class="h-[50px] w-[112px]" alt="图形验证码" />
        </div>
        <button type="button" class="text-[14px] leading-[22px] text-[#0d3f63]" @click="refreshCode">刷新验证码</button>
      </div>

      <div
        class="mt-[20px] flex h-[50px] w-full items-center rounded-[8px] border border-[rgba(5,21,36,0.08)] px-[12px]"
        :class="[{ '!border-[#d84a4a]': figuresmsError }, { '!border-[#292a2e]': smsState }]"
      >
        <input
          v-model.trim="sms"
          type="text"
          maxlength="50"
          class="h-full w-full bg-transparent text-[14px] leading-[22px] text-[#292a2e] placeholder:text-[#7d818a]"
          placeholder="请输入图形验证码"
          @focus="smsState = true"
          @blur="smsState = false"
          @keydown.enter="submit"
        />
      </div>
      <div v-if="figuresmsError" class="mt-[4px] text-[14px] leading-[20px] text-[#d84a4a]">{{ figuresmsError }}</div>

      <button
        type="button"
        class="mt-[24px] flex h-[46px] w-full items-center justify-center rounded-[100px] bg-[#112d73] text-[14px] leading-[22px] font-semibold text-white"
        :class="sms ? '' : 'opacity-40'"
        @click="submit"
      >
        确认
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import CloseIcon from '~/assets/icon/close.svg'

const props = withDefaults(
  defineProps<{
    figuresmsError?: string
    phone?: string
    areaCode?: string
    userId?: string
  }>(),
  {
    figuresmsError: '',
    phone: '',
    areaCode: '',
    userId: '',
  },
)

const emit = defineEmits<{
  close: []
  figuresms: [value: string]
}>()

const { invokeV3 } = useLoginApi()

const smsState = ref(false)
const sms = ref('')
const graphicalImg = ref('')

const refreshCode = async () => {
  const result = await invokeV3('usercenter$getgraphcode', {
    areaCode: props.areaCode,
    userId: props.userId,
    phonenumber: props.phone,
    length: 4,
    width: 112,
    heigth: 50,
  }).catch(() => null)

  if (result?.usercenter?.getgraphcode?.success) {
    graphicalImg.value = result.usercenter.getgraphcode.data || ''
  }
}

const submit = () => {
  if (sms.value) {
    emit('figuresms', sms.value)
  }
}

watch(
  () => props.phone,
  () => {
    sms.value = ''
    refreshCode()
  },
)

onMounted(refreshCode)
</script>
